import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Performer  } from 'src/app/store/performers.era';
import { EditProfileQueryData, SubmitEditProfileData } from 'globals/store/share.data';
import { ShareWrapper } from './share-wrapper.component';
import { CustomQuestion } from 'globals/store/events.data';
import { BrandingData } from 'globals/store/publish.data';
import { CommonModule } from '@angular/common';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { PerformerEditProfileComponent } from './share.editPerformerForm.component';

@Component({
    selector: 'share-edit-performer',
    template: `
<branding-wrapper 
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !performer" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
  <div *ngIf="submitted"  class="thanks">
    Thank you! Your profile information has been submitted.
  </div>
  <share-edit-performer-form *ngIf="!!performer && !submitted"
    [topTitle]="(performer.name || 'Unnamed Performer') + ' Profile in ' + (eventName || 'Unnamed Event')"
    [eventId]="eventId"
    [performer]="performer"
    [publishCode]="publishCode"
    [customQuestions]="customQuestions"
    [error]="error"
    [processing]="processing"
    [template]="template"
    (onSubmit)="submit()">
  </share-edit-performer-form>
</branding-wrapper>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    standalone: true,
    imports: [CommonModule, PerformerEditProfileComponent, BrandingWrapperComponent ],
})
export class PerformerEditComponent extends ShareWrapper<PerformerEditComponent> {
    publishCode: string
    loading: boolean
    processing: boolean
    submitted: boolean
    eventId: string
    eventName: string
    cannotSubmitMessage = "The performer profile can't be submitted at this time.\nPlease reload this page and try again."
    performer:Performer
    inactiveUrlMessage = "The performer profile is not currently available for editing.\n\nTo review or update your profile, please contact the event organiser and ask them to re-activate your edit profile webform."
    customQuestions: CustomQuestion[] = []
    brandingData: BrandingData

    constructor(private route:ActivatedRoute) {
      super()
      this.loading = true;
      document.title = "loading";
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('publishCode')) {
          this.loading = false;
          document.title = "Unavailable";
        } else {
          this.publishCode = params.publishCode;
          const queryData: EditProfileQueryData = { publishCode:this.publishCode, entityType: 'profile' }
          this.publicService.loadEditProfile(queryData).then(profile => {
            this.loading = false;
            if (!profile) {
              document.title = "Unavailable";
              return
            }
            console.log(profile, this.publishCode)
            this.loading = false;
            this.performer = profile.entity as Performer;
            this.eventId = profile.eventId
            this.eventName = profile.eventName
            this.customQuestions = profile.customQuestions || []
            this.brandingData = profile.brandingData
            this.template = profile.brandingData?.template
            document.title = "Edit performer "+this.performer.name;
          })          
        } 
      })
    }

    async submit() {
      this.processing = true;
      const data: SubmitEditProfileData = {
        publishCode:this.publishCode,
        entity:this.performer,
        eventId: this.eventId,
        entityType: 'profile'
      }
      const successfullySubmitted = await this.publicService.submitEditProfile(data)
      this.processing = false;
      if (successfullySubmitted) this.submitted = true;
      else this.showError(this.cannotSubmitMessage)
    }
}

